import type { ReactNode } from 'react';

export const symbol_texture: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M450-130q-8-8-9.5-20t9.5-23l338-338q11-11 23-9.5t20 9.5q9 9 9 21.5t-9 21.5L493-130q-10 10-21.5 10T450-130Zm304 10q-10 0-13.5-9.5T744-146l70-70q7-7 16.5-3.5T840-206v56q0 13-8.5 21.5T810-120h-56Zm-625-11q-8-8-9.5-20t9.5-23l659-656q11-11 23-9.5t20 9.5q8 8 9.5 20t-9.5 23L172-131q-11 11-23 9.5t-20-9.5Zm0-319q-8-8-9.5-20t9.5-23l338-338q11-11 23-9.5t20 9.5q8 8 9.5 20t-9.5 23L172-450q-11 11-23 9.5t-20-9.5Zm-9-304v-56q0-13 8.5-21.5T150-840h56q10 0 13.5 9.5T216-814l-70 70q-7 7-16.5 3.5T120-754Z"
		/>
	</svg>
);
